:host {
  display: block;
  text-align: center;
}

.powered-by {
  background: #FAFAFA;
  color: #484848;
  padding: .75em;
  font-weight: bold;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
  font-size: .65em;
  text-align: center;
  border-radius: 4px;
  transition: all .2s;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
}

.powered-by:hover {
  background: #f2f2f2;
  cursor: pointer;
}

.powered-by .bolt-icon {
  color: #d24919;
  height: 1em;
  width: 1em;
  display: inline;
  padding-right: .25em;
}

.powered-by a,
.powered-by a:hover,
.powered-by a:visited,
.powered-by a:active,
.powered-by a:focus {
  color: #484848;
  text-decoration: none;
}

.powered-by i {
  margin-right: .5em;
}